import { Component, OnInit } from "@angular/core";

import { BaseComponent, UserService, HelperService, environment } from "@mypxplat/xplat/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "@mypxplat/xplat/web/core";
import { filter, take } from "rxjs";
import { BreadcrumbItem } from "../fender-ui/layout-header/layout-header.component";

@Component({
  selector: "myp-account",
  templateUrl: "account.component.html",
  standalone: false,
})
export class AccountComponent extends BaseComponent implements OnInit {
  public breadcrumbs: BreadcrumbItem[] = [];
  public loading: boolean;
  public displayedSection: string;
  public env = environment;
  public sectionMap: any = {
    general: "general.profile",
    orders: "header.nav.orders",
    showcases: "sphere.showcases",
    gift_cards: "sphere.gift_cards",
    plan: environment.studioOnePlusBrandName,
    play_plan: "Fender Play",
    communication_preferences: "account.communication_preferences",
    account_notifications: "account.account_notifications",
    collaboration: "sphere.account.collaboration",
    storage: "sphere.account.storage",
  };
  constructor(
    userService: UserService,
    public helperService: HelperService,
    public appService: AppService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router
  ) {
    super(userService);
  }

  ngOnInit() {
    this.breadcrumbs = [{ label: "header.nav.home", routerLink: ["/home"] }, { label: "fui-header.account", routerLink: ["/account/general"] }, { label: "general.profile" }];
    window.scrollTo(0, 0);
    this.loading = true;
    this.userService.subDetails$
      .pipe(
        filter((item) => !!item),
        take(1)
      )
      .subscribe((result) => {
        this.loading = false;
      });
    this.displayedSection = this._activatedRoute.snapshot.params["category"];
  }

  changeCategory(cat) {
    this.breadcrumbs = [{ label: "header.nav.home", routerLink: ["/home"] }, { label: "fui-header.account", routerLink: ["/account/general"] }, { label: this.sectionMap[cat] }];
    this.displayedSection = cat;
    this._router.navigate(["account/", cat], { replaceUrl: true });
    this.appService.closeModals();
  }
}
